import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-in-finance',
  templateUrl: './bsc-in-finance.component.html',
  styleUrls: ['./bsc-in-finance.component.scss']
})
export class BscInFinanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
